<template>
    <b-card no-body>
        <b-card-header>
            <i class="icon-note"></i>
            <strong>{{
                $t('form.edit', { item: $t('careerObjective.plan') })
            }}</strong>
        </b-card-header>
        <b-card-body>
            <Form
                v-if="!isLoading"
                :careerObjective="careerObjective"
                :isSubmitting="isSubmitting"
                @save="onSubmit"
            />
            <div v-else>
                <c-loader :loader="isLoading" />
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import Form from './Form'
import CLoader from '@/views/components/loader'
import { getParam as getUrlParam } from '@/lib/url'
import { getCareerObjectiveFromApi, updateCareerObjective } from '../../api'
import { mapperFormToApi, mapperApiToForm } from '../../mappers'
import {
    operationSuccessfullySnotification,
    notificationError,
} from '../../functions'

export default {
    name: 'Edit',
    components: {
        Form,
        CLoader,
    },
    data() {
        return {
            id: null,
            isLoading: true,
            isSubmitting: false,
            careerObjective: null,
        }
    },
    mounted() {
        this.id = getUrlParam('id', this)
        this.getCareerObjectiveFromApi()
    },
    methods: {
        getCareerObjectiveFromApi() {
            getCareerObjectiveFromApi(this.id).then(data => {
                this.careerObjective = mapperApiToForm(data)
                this.isLoading = false
            })
        },
        onSubmit(form) {
            this.isSubmitting = true
            const data = mapperFormToApi(form)

            updateCareerObjective(data)
                .then(() => {
                    this.isSubmitting = false
                    operationSuccessfullySnotification('update')
                })
                .catch(e => {
                    console.error(e)
                    notificationError()
                })
                .finally(() => {
                    this.$router.push('/v2/home')
                })
        },
    },
}
</script>
